export function QuestionPhoto({ src }: { src: string }) {
  return (
    <div className="qphoto card">
      <div className="qphoto__inner">
        <img src={src} alt="" />
      </div>
    </div>
  );
}
